import { render } from "./dataRedir.vue?vue&type=template&id=b1f7003e"
import script from "./dataRedir.vue?vue&type=script&lang=js"
export * from "./dataRedir.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.27_vue@3.2.13_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__